// REST surface for a map's source documents: thin ApiService wrappers, one per
// call. ApiService sends credentials and the CSRF header.

import ApiService from '@/utils/ApiService';
import type { SourceDocument, SourceDocumentsResponse } from '../types/SourceDocumentTypes';

function sources(mapId: string | number): string {
  return `/maps/${mapId}/sources`;
}

/** GET …/sources — the map-level documents, or one point's with `nodeId`. */
export function listSourceDocuments(mapId: string | number, nodeId: number | null = null) {
  return nodeId == null
    ? ApiService.get<SourceDocumentsResponse>(sources(mapId))
    : ApiService.get<SourceDocumentsResponse>(sources(mapId), { params: { node_id: nodeId } });
}

/** POST …/sources — attach a file to the map, or to a point with `nodeId`
 *  (multipart; 202, `pending` until its text is extracted). */
export function attachSourceDocumentFile(
  mapId: string | number,
  file: File,
  nodeId: number | null = null
) {
  const form = new FormData();
  form.append('file', file);
  if (nodeId != null) form.append('node_id', String(nodeId));
  return ApiService.post<SourceDocument>(sources(mapId), form);
}

/** POST …/sources — attach a link to the map, or to a point with `nodeId`
 *  (JSON; 202, `pending` until the page's text is extracted). */
export function attachSourceDocumentUrl(
  mapId: string | number,
  url: string,
  nodeId: number | null = null
) {
  return ApiService.post<SourceDocument>(sources(mapId), { url, node_id: nodeId });
}

/** DELETE …/sources/{id} — delete a document and its text (204). */
export function deleteSourceDocument(mapId: string | number, documentId: number) {
  return ApiService.delete(`${sources(mapId)}/${documentId}`);
}
